import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { compressAudio, compressWebM } from '../data/utils';

type MediaUploadProps = {
    data: any;
    setData: any;
};

const MediaUpload: React.FC<MediaUploadProps> = ({
    data,
    setData,
}) => {


    const [isRecordingAudio, setIsRecordingAudio] = useState<any>(false);
    const [audioURLs, setAudioURLs] = useState<string[]>([]);

    
    const [isRecording, setIsRecording] = useState<any>(false);
    const [videoURLs, setVideoURLs] = useState<string[]>([]);
    const [imageURLs, setImageURLs] = useState<string[]>([]);
    const [showFeed, setShowFeed] = useState<any>(false);
    const mediaRecorderRef = useRef<any>(null);
    const [stream, setStream] = useState<any>(null); const mediaRecorderAudioRef = useRef<any>(null);
    const videoRef = useRef<any>(null);
    const files = data.files || [];

    useEffect(() => {
        if (!(data.images || []).length)
            setImageURLs([])
        if (!(data.audios || []).length)
            setAudioURLs([])
        if (!(data.videos || []).length)
            setVideoURLs([])
    }, [data.images, data.audios, data.videos])

    const handleFileUpload = (e: any) => {
        const selected = Array.from(e.target.files || []) as File[];
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const maxSize = 1 * 1024 * 1024;
        const accepted: File[] = [];

        selected.forEach((file) => {
            if (!allowedTypes.includes(file.type)) {
                alert("Invalid file type. Only PDF, JPG, PNG, JPEG, and Excel files are allowed.");
                return;
            }
            if (file.size > maxSize) {
                alert("File size exceeds 1MB.");
                return;
            }
            accepted.push(file);
        });

        if (accepted.length) {
            setData((prevDetails: any) => ({
                ...prevDetails,
                files: [...(prevDetails.files || []), ...accepted],
            }));
        }
        e.target.value = '';
    };

    const removeFile = (e: any, type: string, index: number) => {
        e.preventDefault();
        switch (type) {
            case "audio":
                setAudioURLs((prev) => prev.filter((_, i) => i !== index));
                setData((prevDetails: any) => ({
                    ...prevDetails,
                    audios: (prevDetails.audios || []).filter((_: any, i: number) => i !== index),
                }));
                break;
            case "image":
                setImageURLs((prev) => prev.filter((_, i) => i !== index));
                setData((prevDetails: any) => ({
                    ...prevDetails,
                    images: (prevDetails.images || []).filter((_: any, i: number) => i !== index),
                }));
                break;
            case "video":
                setVideoURLs((prev) => prev.filter((_, i) => i !== index));
                setData((prevDetails: any) => ({
                    ...prevDetails,
                    videos: (prevDetails.videos || []).filter((_: any, i: number) => i !== index),
                }));
                break;
            case "file":
                setData((prevDetails: any) => ({
                    ...prevDetails,
                    files: (prevDetails.files || []).filter((_: any, i: number) => i !== index),
                }));
                break;
        }
    };
    navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
            devices.forEach((device) => {
                if (device.kind === 'videoinput') {

                }
            });
        })
        .catch((error) => console.error('Error listing devices:', error));


    const handleStartCamera = async () => {
        try {

            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevice = devices.find((device) => device.kind === 'videoinput');
            if (videoDevice) {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { deviceId: videoDevice.deviceId },
                    audio: true,
                });
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                setStream(stream);
            } else {
                alert('No camera found!');
            }
        } catch (error: any) {
            console.error('Error accessing camera:', error);
            alert(`Error accessing camera: ${error.message}`);
        }
    };
    const handleCaptureImage = async (e: any) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        const video = videoRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataURL = canvas.toDataURL('image/png');
        setImageURLs((prev) => [...prev, imageDataURL]);
        const compressImage = async (blob: Blob): Promise<Blob> => {
            if (blob.size <= 1 * 1024 * 1024) {
                return blob;
            }

            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    const quality = 0.8; // Initial quality value
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx?.drawImage(img, 0, 0);

                    // Recursive compression logic
                    const compressRecursively = (quality: number) => {
                        canvas.toBlob((compressedBlob) => {
                            if (!compressedBlob || compressedBlob.size <= 1 * 1024 * 1024 || quality <= 0.1) {
                                resolve(compressedBlob!);
                            } else {
                                compressRecursively(quality - 0.1);
                            }
                        }, 'image/jpeg', quality);
                    };

                    compressRecursively(quality);
                };
                img.src = imageDataURL;
            });
        };

        const blob = await (await fetch(imageDataURL)).blob();
        const compressedBlob = await compressImage(blob);

        setData((prevDetails: any) => ({
            ...prevDetails,
            images: [...(prevDetails.images || []), compressedBlob],
        }));
        // handleFeed(e)
    };

    const handleStartRecording = (e: any) => {
        e.preventDefault();
        const stream = videoRef.current.srcObject;
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;

        const chunks: any[] = [];
        mediaRecorder.ondataavailable = (event) => {
            chunks.push(event.data);
        };

        mediaRecorder.onstop = async () => {
            const blob = new Blob(chunks, { type: 'video/webm' });
            const compressedBlob = await compressWebM(blob);
            setVideoURLs((prev) => [...prev, URL.createObjectURL(blob)]);
            setData((prevDetails: any) => ({
                ...prevDetails,
                videos: [...(prevDetails.videos || []), compressedBlob],
            }));

        };

        mediaRecorder.start();
        setIsRecording(true);
    };


    const handleStopRecording = (e: any) => {
        e.preventDefault();
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
            handleFeed(e);
        }
    };
    const handleFeed = (e: any) => {
        e.preventDefault();
        if (!showFeed) {
            handleStartCamera()
        } else {
            handleStopCamera();
        }
        setShowFeed(!showFeed);
    }
    const handleStopCamera = () => {
        if (stream) {
            stream.getTracks().forEach((track: any) => track.stop());
            videoRef.current.srcObject = null;
            setStream(null);
        }
    };
    const handleStartRecordingAudio = async (e: any) => {
        e.preventDefault();
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderAudioRef.current = mediaRecorder;

            const chunks: any[] = [];
            mediaRecorder.ondataavailable = (event) => {
                chunks.push(event.data);
            };

            mediaRecorder.onstop = async () => {
                const blob = new Blob(chunks, { type: 'audio/webm' }); // WebM/opus blob
                const compressedBlob = await compressAudio(blob); // Compress audio
                setAudioURLs((prev) => [...prev, URL.createObjectURL(compressedBlob)]);
                setData((prevDetails: any) => ({
                    ...prevDetails,
                    audios: [...(prevDetails.audios || []), compressedBlob],
                }));
                setIsRecordingAudio(false); // Stop recording state
            };

            mediaRecorder.start();
            setIsRecordingAudio(true);
        } catch (error) {
            console.error('Error accessing microphone:', error);
        }
    };

    const handleStopRecordingAudio = (e: any) => {
        e.preventDefault();
        if (mediaRecorderAudioRef.current) {
            mediaRecorderAudioRef.current.stop();
            setIsRecordingAudio(false);
        }
    };
    return (
        <>
            {/* File Upload Section */}
            <div className="col-md-12">
                <label className="form-label">Upload Attachment</label>
                <div className="bg-light rounded p-2">
                    <div className="profile-uploader border-bottom mb-2 pb-2">
                        <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                            Select File
                            <input
                                type="file"
                                className="form-control image-sign"
                                multiple
                                onChange={handleFileUpload}
                            />
                        </div>
                    </div>
                    {files.map((file: File, index: number) => (
                        <div key={`${file.name}-${index}`} className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                            <div className="d-flex align-items-center">
                                <h6 className="fs-12 fw-medium me-1">{file.name}</h6>
                                <span className="badge badge-soft-info">
                                    {(file.size / (1024 * 1024)).toFixed(2)} MB
                                </span>
                            </div>
                            <Link to="#" className="btn btn-sm btn-icon" onClick={(e) => removeFile(e, 'file', index)}>
                                <i className="ti ti-trash" />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* Voice Note Section */}
            <div className="col-md-12">
                <label className="form-label">Record Voice Note</label>
                <div className="bg-light rounded p-2">
                    <div className="profile-uploader border-bottom mb-2 pb-2">
                        <div className="btn btn-sm px-3">
                            {isRecordingAudio ? (
                                <button className="btn btn-danger btn-sm ms-3 me-3" onClick={handleStopRecordingAudio}>End</button>
                            ) : (
                                <button className="btn btn-success btn-sm ms-3 me-3" onClick={handleStartRecordingAudio}>Start</button>
                            )}
                        </div>
                    </div>
                    {audioURLs.map((url, index) => (
                        <div key={url} className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                            <div className="d-flex align-items-center">
                                <audio controls src={url} />
                            </div>
                            <Link to="#" className="btn btn-sm btn-icon" onClick={(e) => removeFile(e, 'audio', index)}>
                                <i className="ti ti-trash" />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* Image and Video Capture Section */}
            <div className="col-md-12">
                <label className="form-label">Capture Image or Video</label>
                <div className="bg-light rounded p-2">
                    <div className="profile-uploader border-bottom mb-2 pb-2">
                        <div className="text-center px-3">
                            <button onClick={handleFeed} className={`btn ${!showFeed ? 'btn-success' : 'btn-danger'} btn-sm mb-2`}>
                                {!showFeed ? 'Start' : 'Stop'} Camera
                            </button>
                            {showFeed && (
                                <>
                                    <video ref={videoRef} style={{ width: '100%', maxHeight: '300px' }}></video>
                                    <div>
                                        <button className="btn btn-success btn-sm ms-3 me-3 mb-2" onClick={handleCaptureImage}>Capture Image</button>
                                        {!isRecording && (
                                            <button className="btn btn-success btn-sm ms-3 me-3 mb-2" onClick={handleStartRecording}>
                                                Capture Video
                                            </button>
                                        )}
                                        {isRecording && (
                                            <button className="btn btn-danger btn-sm ms-3 me-3 mb-2" onClick={handleStopRecording}>
                                                End Video
                                            </button>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        {imageURLs.map((url, index) => (
                            <div key={url} className="col-md-6">
                                <div className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                                    <div className="d-flex align-items-center">
                                        <img src={url} alt="Captured" style={{ width: '100%' }} />
                                    </div>
                                    <Link to="#" className="btn btn-sm btn-icon" onClick={(e) => removeFile(e, 'image', index)}>
                                        <i className="ti ti-trash" />
                                    </Link>
                                </div>
                            </div>
                        ))}
                        {videoURLs.map((url, index) => (
                            <div key={url} className="col-md-6">
                                <div className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                                    <div className="d-flex align-items-center">
                                        <video src={url} controls style={{ width: '100%' }}></video>
                                    </div>
                                    <Link to="#" className="btn btn-sm btn-icon" onClick={(e) => removeFile(e, 'video', index)}>
                                        <i className="ti ti-trash" />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MediaUpload;
